import React from 'react';

import { useTranslation } from 'react-i18next';

import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import { StyledButton } from '../../../components/button/Button';

export default function ForgetPwd() {
  const { t } = useTranslation();
  const [isFeedback, setIsFeedback] = React.useState(false);
  const [isForget, setIsForget] = React.useState(true);

  const [state, setState] = React.useState({
    username: '',
    error: false,
  });

  const onChange = (e) => {
    const { name, value } = e.target;
    setState({ ...state, [name]: value });
  };

  const onSubmit = (e) => {
    e.preventDefault();

    const { username } = state;

    fetch(`${process.env.REACT_APP_BACKOFFICE_API_URL}/api/v1/password/sendemail`, {
      method: 'post',
      headers: {
        Accept: 'application/x-www-form-urlencoded',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: username,
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        console.log(response);
        if (response.success !== undefined && response.success === false) {
          setState({ ...state, error: response.message });
        } else {
          setIsFeedback(!isFeedback);
          setIsForget(false);
        }

        return response;
      });
  };

  function Feedback() {
    const { username } = state;
    return (
      <>
        <Grid item align="center" id="reset-feedback">
          <Typography variant="h6" style={{ fontSize: '12px', color: '#555' }}>{t('ระบบได้ส่งลิงค์ยืนยันตั้งรหัสผ่านใหม่ของคุณ ทางอีเมล์เรียบร้อยแล้ว')}</Typography>
          <Typography variant="h6" style={{ fontSize: '12px', color: '#555' }}>
            Email :
            <Typography color="primary" style={{ fontSize: '12px' }} display="inline">{username}</Typography>
          </Typography>
          <Typography variant="h6" style={{ fontSize: '12px', color: '#555' }}>{t('กรุณายืนยัน')}</Typography>
        </Grid>
      </>
    );
  }
  return (
    <>
      <Box color="error.main" id="login-error-forget">{state.error}</Box>
      <Grid container direction="column" spacing={5} style={{ marginTop: 10 }}>
        {isForget && (
          <>
            <Grid item md align="left">
              <FormControl required>
                <Typography variant="h6" style={{ fontSize: '16px', color: '#555' }}>{t('ป้อนอีเมล์ของคุณ')}</Typography>
                <TextField
                  id="forgot-password"
                  name="username"
                  placeholder=""
                  InputProps={{
                    startAdornment: <InputAdornment position="start" />,
                  }}
                  onChange={onChange}
                />
              </FormControl>
            </Grid>
            <Grid item align="center">
              <FormControl style={{ width: '70%', marginTop: 20 }}>
                <StyledButton onClick={onSubmit} >
                  {t('ถัดไป')}
              </StyledButton>
              </FormControl>
            </Grid>
          </>
        )}
        {isFeedback && <Feedback />}
      </Grid>
    </>
  );
}
